exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monitoring-card-link[data-v-34b7a5ce]{display:block;text-decoration:none;color:inherit}.monitoring-card-link[data-v-34b7a5ce]:hover{text-decoration:none}.monitoring-card[data-v-34b7a5ce]{cursor:pointer;transition:transform .15s ease,box-shadow .15s ease;border:1px solid #ebedf2}.monitoring-card[data-v-34b7a5ce]:hover{transform:translateY(-3px);box-shadow:0 .5rem 1rem rgba(0,0,0,.1);border-color:#5867dd}.monitoring-card-icon[data-v-34b7a5ce]{padding-top:10px}.monitoring-card-title[data-v-34b7a5ce]{font-weight:500;color:#48465b}.monitoring-card-desc[data-v-34b7a5ce]{font-size:.9rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-34b7a5ce","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Monitoring/MonitoringHub.vue
// module id = 1076
// module chunks = 0